import React, {useEffect, useRef, useState} from 'react';
import { alertSurface } from '../theme';
import classNames from 'classnames';
import { Typography, Button, Link, Collapse, Paper, Box, Grow, Tooltip, Divider, Stepper, Step, StepLabel, CircularProgress } from '@mui/material';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import LoopIcon from '@mui/icons-material/Loop';
import { useTranslation, Trans } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { publishTranslations, unpublishTranslations } from '../modules/themes';
import { syncThemeAppExtension, checkThemePublishState } from '../modules/themeAppExtension';
import { solutionsArticleUrl } from '../config/solutionsArticles';



/**
 * 
 * @param {*} param0 
 * @returns 
 */
const LangifyActivation = ({ activate, myshopifyDomain, template, handle }) => {
  const { t } = useTranslation(); 
  const [loading, setLoading] = useState(false);

  const edit_theme = useSelector((state) => state.themes.edit_theme);
  const themes = useSelector((state) => state.themes.themes);
  const uuid = useSelector((state) => state.themeAppExtension.uuid);
  const disabled = useSelector((state) => state.themeAppExtension.disabled);
  const langify_code_in_theme = useSelector((state) => state.themeAppExtension.langify_code_in_theme);
  const langify_app_embed_code_in_theme = useSelector((state) => state.themeAppExtension.langify_app_embed_code_in_theme);
  const settings = useSelector((state) => state.themeAppExtension.settings);
  const dispatch = useDispatch();
  

  useEffect(() => {
    return function() {
      document.removeEventListener('visibilitychange', handleBrowserTabFocus);
    }
  }, [])

  const handleBrowserTabFocus = () => {
    if (document.visibilityState === 'visible') {
      setLoading(true);
      dispatch(syncThemeAppExtension(edit_theme, (res) => {
        dispatch(checkThemePublishState(edit_theme, (res2) => {

          setLoading(false);
        }));
      }));
    }
  }

  const handleButtonClick = () => {
    const editTheme = themes.find(x => x.id == edit_theme).shopify_id || 'current';
    const editorUrl = `https://${myshopifyDomain}/admin/themes/${editTheme}/editor?context=apps${template ? '&template=' + template : ''}${uuid ? '&activateAppId=' + uuid : ''}/${handle}`;

    //navigator.clipboard.writeText(editTheme);

    var textToCopy = editTheme;
    var textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    // 
    document.removeEventListener('visibilitychange', handleBrowserTabFocus);
    document.addEventListener('visibilitychange', handleBrowserTabFocus);
    window.open(editorUrl, '_blank');
    //console.log(editorUrl)
  };

  const renderCustomizeThemeDeepLink = <Button variant="contained" color="primary" size="small" onClick={handleButtonClick} sx={styles.deeplinkBtn}>
    Open Customize Theme Editor <OpenInNewIcon sx={styles.icon} />
  </Button>

  const renderCustomizeThemeIdDeepLink = <Button variant="outlined" size="small" onClick={handleButtonClick} sx={styles.deeplinkBtn}>
    Open Customize Theme Editor <OpenInNewIcon sx={styles.icon} />
  </Button>

  const showThemeIdAlert = () => {
    const editTheme = themes.find(x => x.id == edit_theme);
    let _return = false;
    if(settings.theme_id === '')
      _return = 'empty';
    if(settings.theme_id !== '') {
      if(editTheme && editTheme.shopify_id && (editTheme.shopify_id != settings.theme_id)) {
        _return = 'different';
      }
    }
    return _return;
  }

  // shown literally in the theme id alert, next to the copy button
  const currentThemeShopifyId = themes.find(x => x.id == edit_theme)?.shopify_id || '';

  return (
    <div>
      {activate &&
        <React.Fragment>
          <Typography variant="h5" component="h3" sx={styles.headline}>
            {t('themeAppExtension.themeSettings.publishButton')}
          </Typography>
          <Typography variant="body2" gutterBottom>
            <Trans i18nKey={'themeAppExtension.themeSettings.langifyNotEnabledMessage'} />
            <br/>
            <br/>
            <Trans i18nKey={'themeAppExtension.themeSettings.activationSteps'} />
            <br/>
            <br/>
            <React.Fragment>
              {t('themeAppExtension.themeSettings.directButtonMessage')}
              <br/>
              {renderCustomizeThemeDeepLink}
            </React.Fragment>
            <br/>
            <br/>
            {t('themeAppExtension.themeSettings.recommendedSettingsMessage')}
            <br/>
            <br/>
            {t('themeAppExtension.themeSettings.getDetailsLinkMessage')}
            <br/>
            <a href={solutionsArticleUrl('publishingLangify')} target="_blank" rel="noopener noreferrer">Publishing langify</a>
          </Typography>
        </React.Fragment>
      }
      {!activate &&
        <React.Fragment>

          <Typography variant="h5" component="h3" sx={styles.headline}>
            <CheckCircleOutlineOutlinedIcon className={classNames((typeof uuid === 'string' && disabled === false) ? 'green' : null)} sx={styles.publishCheckMark} /> {t('themeAppExtension.themeSettings.langifyPublishedMessage')} 
          </Typography>

          {showThemeIdAlert() !== false &&
            <Alert severity="error" style={{marginBottom: 12}}>
              <Trans i18nKey={`themeAppExtension.themeSettings.themeIdAlerts.${showThemeIdAlert()}`} values={{ themeId: currentThemeShopifyId }}>
                <strong>t('themeAppExtension.themeSettings.provideThemeId')</strong>
                <br/>
                t('themeAppExtension.themeSettings.addThemeIdPrompt')
                <br/>
              </Trans>
              {renderCustomizeThemeIdDeepLink}
            </Alert>
          }

          <Typography variant="body2" gutterBottom>
            {/*  (
            {(isPublished || isPublishedInTheme) && t('themeAppExtension.themeSettings.publishedInTheme')}
            {(uuid && !disabled) && t('themeAppExtension.themeSettings.publishedAppEmbedBlock')}
            ) */}
            {t('themeAppExtension.themeSettings.deactivateInstructions')}
            <br/>
            <br/>
            <React.Fragment>
              {t('themeAppExtension.themeSettings.directButtonMessage')}
              <br/>
              {renderCustomizeThemeDeepLink}
            </React.Fragment>
          </Typography>        
        </React.Fragment>
      }
      {(loading) &&
        <Box sx={styles.loadingLayer}>
          <span style={styles.loadingSpinner}>
            <CircularProgress />
          </span>
        </Box>
      }
    </div>
  );
};
export default LangifyActivation;



/**
 * 
 */
export const ManuallyAddLangifyCode = ({forceHide, publish, showAlways, showInline, showCheckMark, hideHeadline, hideDescription, style}) => {
  const lyDelimiter = '{% comment %}ly_liquid_scripts_begin{% endcomment %}{% capture ly_liquid_content %}{% comment %}ly_liquid_scripts_end{% endcomment %}<!doctype html>';
  const lyPolyfillCodeDelimiter = /\{%\s*comment\s*%\}ly_liquid_scripts_begin\{%\s*endcomment\s*%\}\{%\s*endcapture\s*%\}(?:\{%-\s*comment\s*-%\}Version)?/;
  const [oldTemplateData, setOldTemplateData] = useState(null);

  const { t } = useTranslation();
  const [started, setStarted] = useState(false);
  const [hidden, setHidden] = useState(forceHide);
  const [publishing, setPublishing] = useState(publish);
  const [activeStep, setActiveStep] = React.useState(0);
  const [keepOpen, setKeepOpen] = React.useState(false);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [generateCodeCompleted, setGenerateCodeCompleted] = useState(false);
  const [templateData, setTemplateData] = useState(null);
  const [error, setError] = useState(false);
  const [errorInfo, setErrorInfo] = useState({
    title: '',
    message: '',
  });
  const errorRef = useRef(error);
  const errorInfoRef = useRef(errorInfo);

  const synced = useSelector((state) => state.themeAppExtension.synced);
  const uuid = useSelector((state) => state.themeAppExtension.uuid);
  const disabled = useSelector((state) => state.themeAppExtension.disabled);
  const langify_code_in_theme = useSelector((state) => state.themeAppExtension.langify_code_in_theme);
  const langify_app_embed_code_in_theme = useSelector((state) => state.themeAppExtension.langify_app_embed_code_in_theme);
  const theme_liquid_path = useSelector((state) => state.themeAppExtension.theme_liquid_path);
  const sync_theme_app_extension_pending = useSelector((state) => state.themeAppExtension.sync_theme_app_extension_pending);
  const sync_theme_app_extension_failed = useSelector((state) => state.themeAppExtension.sync_theme_app_extension_failed);
  const themes = useSelector((state) => state.themes.themes);
  const edit_theme = useSelector((state) => state.themes.edit_theme);
  const dispatch = useDispatch();

  useEffect(() => {   
    document.addEventListener('visibilitychange', handleBrowserTabFocus);
    
    return () => {
      document.removeEventListener('visibilitychange', handleBrowserTabFocus);
    };
  }, [activeStep, generateCodeCompleted]);

  useEffect(() => {
    errorRef.current = error;
    errorInfoRef.current = errorInfo;
  }, [error, errorInfo]);

  useEffect(() => {
    //debugger;
    if(synced === false && sync_theme_app_extension_pending === false && sync_theme_app_extension_failed === false && _isValidEditThemeId()) {
      dispatch(syncThemeAppExtension(edit_theme));
      dispatch(checkThemePublishState(edit_theme), (res) => {
        //console.log(res, '####')
      });
    }
    if(!keepOpen) {
      setPublishing(publish);
    }
    setHidden(forceHide);
    //console.log({publish, publishing})
  }, [synced, sync_theme_app_extension_pending, sync_theme_app_extension_failed, publish, keepOpen, forceHide])

  const handleBack = (e) => {
    e.stopPropagation();
    setStarted(false);
  }

  const handleStart = (e) => {
    e.stopPropagation();
    setStarted(true);
  }

  const _isValidEditThemeId = () => {
    return themes.find(x => x.id === edit_theme) ? true : false;
  }

  const _checkDoubleSize = (str1, str2, str3) => {
    const size1 = str1.length;
    const size2 = str2.length;
    const size1Plus2 = size1 + size2;
    const size3 = str3.length;

    // Berechnung der Größe um 5% zu erweitern
    const lowerBound = size1Plus2 * 0.95;
    const upperBound = size1Plus2 * 1.05;

    // Überprüfen, ob size3 zwischen den Grenzen liegt
    return size3 >= lowerBound && size3 <= upperBound;
  }
  
  const handleGenerateCode = () => {
    setGenerating(true);

    dispatch(publishTranslations(edit_theme, false, (res) => {
      if(res.success === false) {
        setActiveStep(0);
        setError(true);
        setErrorInfo({
          title: t('themeAppExtension.manuallyAddLangifyCode.errorTitleCodeCannotBeGenerated'),
          message: t('themeAppExtension.manuallyAddLangifyCode.errorMessageBodyTag'),
         });
      } else {
        setOldTemplateData(res);
        setTemplateData(res);
        setActiveStep(1);        
      }
      setGenerating(false);
      setGenerateCodeCompleted(true);

      console.log(res);
    }));
  }

  const handleOpenTemplate = () => {
    const url = theme_liquid_path ?? templateData.theme_liquid_path;
    window.open(url, '_blank');
  }

  const handleBrowserTabFocus = () => {
    if (document.visibilityState === 'visible' && (activeStep === 1 || (started === true && activeStep === 0 && errorRef.current === true))) {
      setLoading(true);
      setCopied(false);

      let changeDetected = false;

      const dispatchCheckTheme = (attempt) => {
        dispatch(checkThemePublishState(edit_theme, (res) => {
          const { hasError, hasErrorTitle, hasErrorMessage } = checkForErrors(res, oldTemplateData);
  
          if(errorInfoRef.current.message !== hasErrorMessage || errorRef.current !== hasError) {
            changeDetected = true;
          }

          setError(hasError);
          setErrorInfo({ title: hasErrorTitle, message: hasErrorMessage });
  
          if (!hasError) {
            if (publish) {
              if(lyPolyfillCodeDelimiter.test(res.value.value)) {
                changeDetected = true;
                setActiveStep(2);
                setKeepOpen(true);
                document.removeEventListener('visibilitychange', handleBrowserTabFocus);
              }
            } else {
              if(!lyPolyfillCodeDelimiter.test(res.value.value)) {
                changeDetected = true;
                setActiveStep(2);
                setKeepOpen(true);
                document.removeEventListener('visibilitychange', handleBrowserTabFocus);
              }
            }
          }

          if(attempt === 1 && changeDetected === false) {
              setTimeout(() => dispatchCheckTheme(2, res), 1000);
          } else {
            setLoading(false);
          }

        }));
      }
      dispatchCheckTheme(1);
    }
  };

  function checkForErrors(res, oldTemplateData) {
    let hasError = false;
    let hasErrorTitle = '';
    let hasErrorMessage = '';
  
    // Check for more than one </body> tag OR no <body> tag
    if (res.value.value.split('</body>').length > 2 || res.value.value.includes('<body') === false) {
      hasError = true;
      hasErrorTitle = t('themeAppExtension.manuallyAddLangifyCode.errorTitleCodeCannotBeGenerated');
      hasErrorMessage = t('themeAppExtension.manuallyAddLangifyCode.errorMessageBodyTag');
    }
  
    // Check if DAU pasted the entire code at the end of the theme.liquid instead of replacing the code
    if (oldTemplateData) {
      const codePublished = oldTemplateData.theme_liquid_value_published;
      const codeUnpublished = oldTemplateData.theme_liquid_value_unpublished;
      const currentCode = res.value.value; // reality
      if (_checkDoubleSize(codePublished, codeUnpublished, currentCode)) {
        hasError = true;
        hasErrorTitle = publish ? t('themeAppExtension.manuallyAddLangifyCode.errorTitlePolyfillAddedIncorrectly') : t('themeAppExtension.manuallyAddLangifyCode.errorTitlePolyfillRemovedIncorrectly');
        hasErrorMessage = t('themeAppExtension.manuallyAddLangifyCode.errorMessageDoubledThemeFileSize');
      }
    }
  
    return { hasError, hasErrorTitle, hasErrorMessage };
  }

  const handleCopyToClipboard = () => {
    var textToCopy = templateData.theme_liquid_value_published;
    if(publish === false) {
      textToCopy = templateData.theme_liquid_value_unpublished;
    }

    var textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();

    document.execCommand('copy');
    document.body.removeChild(textArea);

    setCopied(true);
    /*
    setTimeout(() => {
      setCopied(false);
    }, 3000);
    */
  }

  const handleFinished = () => {
    setKeepOpen(false);
    setStarted(false);
    setActiveStep(0);
  }

  const handleCancel = () => {
      setKeepOpen(false);
      setStarted(false);
      setActiveStep(0);
      setError(false);
      setErrorInfo('', null);
  }

  const steps = [
    publishing ? t('themeAppExtension.manuallyAddLangifyCode.generateCode') : t('themeAppExtension.manuallyAddLangifyCode.unpublishGenerateCode'),
    t('themeAppExtension.manuallyAddLangifyCode.replaceTemplateCode'),
    t('themeAppExtension.manuallyAddLangifyCode.finish')
  ]

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Typography>
            {publishing && t('themeAppExtension.manuallyAddLangifyCode.generateCodeDescription')}
            {!publishing && t('themeAppExtension.manuallyAddLangifyCode.unpublishGenerateCodeDescription')}
            <br />
            <Button onClick={handleGenerateCode} disabled={generating} sx={styles.stepperBtn} variant="contained" color="primary" size="small">
              {generating ? t('themeAppExtension.manuallyAddLangifyCode.generating') : t('themeAppExtension.manuallyAddLangifyCode.generateCodeBtn')}
            </Button>
            <Button onClick={handleCancel} sx={styles.stepperBtn} variant="outlined" color="primary" size="small">
              {t('system.cancel')}
            </Button>
          </Typography>
        );
      case 1:
        return (
          <Typography>
            <Trans i18nKey={'themeAppExtension.manuallyAddLangifyCode.replaceTemplateCodeDescription'}></Trans><br />
            <Button onClick={handleCopyToClipboard} sx={styles.stepperBtn} size="small" variant="contained" color={copied ? 'default' : 'secondary'}>
              <FileCopyOutlinedIcon style={{ marginRight: 8, fontSize: 16 }} /> {t('themeAppExtension.manuallyAddLangifyCode.copyToClipboard')}
            </Button>
            <Button onClick={handleOpenTemplate} sx={styles.stepperBtn} size="small" variant="contained" color="primary">
              <OpenInNewOutlinedIcon style={{ marginRight: 8, fontSize: 16 }} /> {t('themeAppExtension.manuallyAddLangifyCode.openTemplate')}
            </Button>
            <Button onClick={handleCancel} sx={styles.stepperBtn} size="small" variant="outlined" color="primary">
              {t('system.cancel')}
            </Button>
          </Typography>
        );
      case 2:
        return (
          <Typography>
            {t('themeAppExtension.manuallyAddLangifyCode.finishDescription')}<br />
            <Button onClick={handleFinished} sx={styles.stepperBtn} size="small" variant="contained" color="primary">
              {t('themeAppExtension.manuallyAddLangifyCode.done')}
            </Button>
          </Typography>
        );
      default:
        return t('themeAppExtension.manuallyAddLangifyCode.unknownStep');
    }
  };

  const NoticeBox = showInline ? Paper : Alert;

  return <div style={{position: 'relative', ...(style ? style : {})}}>
    {/* unmounted while hidden: the exited Collapse keeps a zero-height box between the page's
        divider and the next notice, which stops their margins from collapsing into one */}
    {!forceHide &&
      <Collapse in={(uuid && langify_app_embed_code_in_theme === false && langify_code_in_theme === false) || showAlways || keepOpen} unmountOnExit sx={{ '& .MuiCollapse-wrapper': styles.collapseWrapper, width: '100%' }}>
        {/* boxed: an info alert like every other banner; inline: a headline with text inside a section */}
        <NoticeBox {...(showInline ? { sx: styles.inlineInfoBox, elevation: 0 } : { severity: 'info', sx: styles.infoBox })}>
          {!hideHeadline &&
            <React.Fragment>
              {!showInline ?
                <AlertTitle>{t('themeAppExtension.manuallyAddLangifyCode.title')}</AlertTitle>
              :
                <Typography variant="h5" component="h3" sx={styles.headline}>
                  {showCheckMark && <CheckCircleOutlineOutlinedIcon className={classNames(langify_app_embed_code_in_theme ? 'green' : null)} sx={styles.publishCheckMark} /> }  
                  {publishing && t('themeAppExtension.manuallyAddLangifyCode.publishTitle')}
                  {!publishing && t('themeAppExtension.manuallyAddLangifyCode.unpublishTitle')}
                </Typography>
              }
            </React.Fragment>
          }

          {!hideDescription && !error &&
            <Typography variant="body2">
              {publishing && <Trans i18nKey={'themeAppExtension.manuallyAddLangifyCode.description'}></Trans>}
              {!publishing && <Trans i18nKey={'themeAppExtension.manuallyAddLangifyCode.unpublishDescription'}></Trans>}
            </Typography>
          }

          {!error &&
            <Collapse in={started} style={{ width: '100%' }}>
              <Stepper activeStep={activeStep} sx={styles.stepperRoot}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel completed={(activeStep === 2 && keepOpen) || index === activeStep - 1} {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              <div>
                {getStepContent(activeStep)}
              </div>
            </Collapse>
          }
          {!started && !error &&
            <Button onClick={handleStart} sx={styles.stepperBtn} variant="outlined" size="small">
              {publishing && t('themeAppExtension.manuallyAddLangifyCode.startManualPublishing')}
              {!publishing && t('themeAppExtension.manuallyAddLangifyCode.startManualUnpublishing')}
            </Button>
          }

          {error && (
              <Alert severity="error" style={{ marginBottom: 12}}>
                  <Trans>
                    <>
                      {errorInfo.title && (
                        <>
                          <strong>{ errorInfo.title }</strong>
                          <br />
                          {t('themeAppExtension.manuallyAddLangifyCode.ifYouNeedAssistance')}
                          <br />
                        </>
                      )}
                    </>
                  </Trans>

                  {errorInfo.message && (
                    <>
                      <br />
                      {/* not in <Trans> tag because message contains HTML that should be displayed as plain text*/}
                      <strong>{t('themeAppExtension.manuallyAddLangifyCode.details')}:</strong> {errorInfo.message}
                      <br />
                    </>
                  )}

                  <Button variant="outlined" size="small" onClick={handleOpenTemplate} sx={styles.stepperBtn}>
                    <OpenInNewOutlinedIcon style={{ marginRight: 8, fontSize: 16 }} /> {t('themeAppExtension.manuallyAddLangifyCode.openTemplate')}
                  </Button>

                  <Button variant="outlined" size="small" onClick={handleBrowserTabFocus} sx={styles.stepperBtn}>
                    <LoopIcon style={{ marginRight: 8, fontSize: 16 }}/>{t('system.checkAgain')}
                  </Button>

              </Alert>
          )}

          {(loading || generating) &&
            <Box sx={styles.loadingLayer}>
              <span style={styles.loadingSpinner}>
                <CircularProgress />
              </span>
            </Box>
          }
        </NoticeBox>      
      </Collapse>
    }
  </div>
}



export const CopyPasteSingleFile = ({ template, url, value, publish }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleOpenTemplate = () => {
    window.open(url, '_blank');
  }

  const handleCopyToClipboard = (isUnpublished=false) => {
    var textToCopy = value;
    var textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();

    document.execCommand('copy');
    document.body.removeChild(textArea);

    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }

  return <Box className={classNames(publish ? 'publish' : 'unpublish')} sx={styles.singleFileRoot}>
  <Divider sx={styles.divider2} />    
  <span>
    <strong>{publish ? t('themeAppExtension.copyPasteSingleFile.publishAsset') : t('themeAppExtension.copyPasteSingleFile.unpublishAsset')} </strong>
    {template}
  </span>
  <span>
    <Tooltip title={t('themeAppExtension.copyPasteSingleFile.copyToClipboard')} arrow>
      <Button onClick={() => {handleCopyToClipboard(publish)}} size="small" variant="outlined" sx={styles.btn}>
        <FileCopyOutlinedIcon style={{marginRight: 8, fontSize: 16}} />
        {copied && t('themeAppExtension.copyPasteSingleFile.copiedCode')}
        {(!copied && publish) && t('themeAppExtension.copyPasteSingleFile.copyPublishedCode')}
        {(!copied && !publish) && t('themeAppExtension.copyPasteSingleFile.copyUnpublishedCode')}
      </Button>
    </Tooltip>
    <Tooltip title={t('themeAppExtension.copyPasteSingleFile.openTemplate')} arrow>
      <Button onClick={handleOpenTemplate} size="small" variant="outlined" sx={styles.btn}>
        <OpenInNewOutlinedIcon style={{marginRight: 8, fontSize: 16}} />{t('themeAppExtension.copyPasteSingleFile.open')}
      </Button>
    </Tooltip>     
  </span>
</Box>
}


const styles = {
  root: {
    position: 'relative'
  },
  icon: {
    marginLeft: '8px'
  },
  headline: {
    marginBottom: '8px'
  },
  collapseWrapper: {
    width: '100%',
  
  },
  btn: {
    wordBreak: 'normal',
    marginLeft: '8px'
  },
  deeplinkBtn: {
    marginTop: '8px'
  },
  cancelBtn: {

  },
  divider: {
    margin: '8px 0',
  },
  divider2: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%'
  },
  /**
   * `rgb(241, 243, 249)` war exakt `lighten(secondary.light, 0.9)` — ein von
   * Hand eingetragener Themewert, der nur im Light-Modus stimmte. Im Dark Mode
   * blieb die Fläche hell, während die Beschreibung darauf `text.primary` erbte
   * und mit 1.10:1 verschwand; die Überschrift blieb lesbar, weil sie
   * hartcodiert war — daher wirkte die Box nur halb kaputt.
   *
   * `accentSurface` ist das Token für genau diese Rolle (getönte Indigo-Fläche
   * mit passendem Text) und existiert in beiden Paletten. Der schwarze
   * Alpha-Rand ist auf `divider` umgestellt, weil er auf dunklem Grund
   * unsichtbar war.
   */
  // no top margin: the boxed notice sits under a page divider that brings the distance itself,
  // and the Collapse around it would keep the two margins from collapsing into one
  infoBox: {
    position: 'relative',
    '& .MuiAlert-message': { width: '100%' },
  },
  infoBox2: {
    backgroundColor: 'accentMuted',
    padding: '12px 24px',
    border: 'solid 1px rgba(0,0,0,.05)',
    marginTop: '20px',
  },
  infoText2: {
    color: '#b5bce6',
  },

  // inline, this is body text like the instructions around it, not a banner
  inlineInfoBox: {
    position: 'relative',
  },


  singleFileRoot: (theme) => ({
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 16px',
    '&.publish': {
      ...alertSurface(theme, 'error', { opacity: 0.32 }),
      '& *': {
        color: 'inherit',
        borderColor: 'currentColor',
      },
    },
  }),
  // Weisser Lade-Schleier, im Dark Mode eine hell aufleuchtende Fläche. Gleiche
  // Verzweigung wie das MuiBackdrop-Override in theme.js.
  loadingLayer: (theme) => ({
    position: 'absolute',
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,.5)' : 'rgba(255,255,255,.5)',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 999,
    '& .MuiCircularProgress-root': {
    }
  }),
  loadingSpinner: {
    position: 'relative',
    display: 'inline-block',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },

  stepperRoot: {
    padding: '16px 0',
    backgroundColor: 'transparent',
  },
  stepperBtn: {
    margin: '8px 8px 8px 0',
  },

  publishCheckMark: {
    marginBottom: '4px',
    marginRight: '8px',
    fontSize: 30,
    // `lightgrey` war der „noch nicht erledigt"-Zustand. Auf dunklem Grund ist
    // rgb(211,211,211) hell und damit auffälliger als der erledigte Zustand —
    // die Semantik kippt. `action.disabled` folgt dem Modus und bleibt in
    // beiden dezent.
    color: 'action.disabled',
    '&.green': {
      color: 'green'
    }
  }
};